export const isDatadogSynthetics = (ua: string) =>
  /.*Datadog\/?Synthetics.*/.test(ua);
